/*! Ardor Printing table cover 3D preview v1.0 (window.ArdorTable3D).
 * Needs global THREE (r147) and THREE.OrbitControls loaded first. No other files, no network loads.
 * Units are inches, y up, the table's front faces +z. The cover is one cloth mesh built over the
 * template (u, v in inches from the template's top-left, v down), so the print canvas maps 1:1. */
(function (root) {
  "use strict";

  var FOV = 28, EL_MAX = 1.45, EL_MIN = 0.02, DEFAULT_BG = "#f4f6f5", PI = Math.PI, S2 = Math.SQRT1_2,
    FILL_HOME = 0.9, FILL_NEAR = 0.97, FILL_FAR = 0.45, FLOOR = 0.12, BOARD = 1.75;
  // camera views: [azimuth (0 = front, +PI/2 = right side), elevation]
  var VIEWS = {
    home: [0.62, 0.3], front: [0, 0.1], back: [PI, 0.1], left: [-PI / 2, 0.1], right: [PI / 2, 0.1],
    side: [1.12, 0.2], top: [0, 1.4]
  };

  function hasThree() {
    var T = root.THREE;
    return !!(T && T.WebGLRenderer && T.OrbitControls && T.BufferGeometry && T.MeshLambertMaterial &&
      T.ShapeUtils && T.CanvasTexture && T.CylinderGeometry && T.BoxGeometry);
  }

  function create(host, opts) {
    try { return !host || !hasThree() ? null : build(host, opts || {}); } catch (e) {
      try { // clean up a half-built viewer so the page can fall back to 2D
        var cs = host.querySelectorAll("canvas[data-ardor-table3d='init']"), i, gl, ext;
        for (i = 0; i < cs.length; i++) {
          gl = cs[i].getContext("webgl2") || cs[i].getContext("webgl");
          ext = gl && gl.getExtension("WEBGL_lose_context");
          if (ext) ext.loseContext();
          if (cs[i].parentNode) cs[i].parentNode.removeChild(cs[i]);
        }
      } catch (e2) { }
      return null;
    }
  }

  /* ---------- input helpers (lenient: specs JSON or Shopify option text) ---------- */
  function num(v, lo, hi) {
    var n = Number(v);
    return v !== null && v !== "" && v !== true && v !== false && isFinite(n) && n >= lo && n <= hi ? n : null;
  }
  function str(v) { return v === null || v === undefined ? "" : String(v).toLowerCase().replace(/^\s+|\s+$/g, ""); }
  function keyOf(v) { return typeof v === "string" ? v.replace(/^\s+|\s+$/g, "") : ""; }
  function famOf(v, key) {
    var s = str(v);
    if (s.indexOf("fit") >= 0) return "fitted";
    if (s.indexOf("stretch") >= 0 || s.indexOf("spandex") >= 0) return "stretch";
    if (s.indexOf("round") >= 0 || s.indexOf("circ") >= 0) return "round";
    if (s.indexOf("run") >= 0) return "runner";
    if (s.indexOf("throw") >= 0 || s.indexOf("loose") >= 0) return "throw";
    var k = key.slice(0, 2).toUpperCase();
    return k === "FT" ? "fitted" : k === "ST" ? "stretch" : k === "RD" ? "round" : k === "RN" ? "runner" : k === "TT" ? "throw" : null;
  }
  function sidesOf(v, key) {
    if (v === 3 || v === 4) return v;
    var s = str(v), m;
    if (/^3|three|open/.test(s)) return 3;
    if (/^4|four|closed/.test(s)) return 4;
    m = /-(3|4)$/.exec(key);
    return m ? +m[1] : 0;
  }
  function colorOf(v) {
    if (typeof v !== "string") return null;
    v = v.replace(/^\s+|\s+$/g, "");
    return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v) ? v : null;
  }
  function bgColor(v) { return colorOf(v) || DEFAULT_BG; }
  function arr(v, n) {
    if (!v || typeof v !== "object" || typeof v.length !== "number" || v.length < n) return null;
    var o = [], i, x;
    for (i = 0; i < n; i++) { x = Number(v[i]); if (v[i] === null || !isFinite(x)) return null; o.push(x); }
    return o;
  }
  function rectPoly(r) { return [[r[0], r[1]], [r[0] + r[2], r[1]], [r[0] + r[2], r[1] + r[3]], [r[0], r[1] + r[3]]]; }
  function circlePoly(cx, cy, r, n) {
    var p = [], i;
    for (i = 0; i < n; i++) p.push([cx + r * Math.cos(2 * PI * i / n), cy + r * Math.sin(2 * PI * i / n)]);
    return p;
  }
  function cleanPoly(v) {
    if (!v || typeof v.length !== "number" || v.length < 3) return null;
    var out = [], i, p, x, y, n;
    for (i = 0; i < v.length && i < 4000; i++) {
      p = v[i];
      if (!p || typeof p !== "object") continue;
      x = Number(p.length !== undefined ? p[0] : p.x);
      y = Number(p.length !== undefined ? p[1] : p.y);
      if (!isFinite(x) || !isFinite(y)) continue;
      n = out.length;
      if (n && Math.abs(out[n - 1][0] - x) < 1e-4 && Math.abs(out[n - 1][1] - y) < 1e-4) continue;
      out.push([x, y]);
    }
    while (out.length > 2 && Math.abs(out[0][0] - out[out.length - 1][0]) < 1e-4 &&
      Math.abs(out[0][1] - out[out.length - 1][1]) < 1e-4) out.pop();
    return out.length >= 3 && Math.abs(area(out)) > 1 ? out : null;
  }
  function cutOf(c, depth) {
    if (!c || typeof c !== "object" || depth > 2) return null;
    var t = str(c.type), r = arr(c.rect, 4) || (t === "rect" ? arr([c.x, c.y, c.w, c.h], 4) : null),
      ci = arr(c.circle, 3) || (t === "circle" ? arr([c.cx, c.cy, c.r], 3) : null), p, k, out, sub;
    if (c.pieces && typeof c.pieces === "object") { // separate printed pieces sewn together
      out = [];
      for (k in c.pieces) if (c.pieces.hasOwnProperty(k)) { sub = cutOf(c.pieces[k], (depth || 0) + 1); if (sub) out = out.concat(sub.polys); }
      return out.length ? { polys: out } : null;
    }
    if (r && r[2] > 1 && r[3] > 1) return { rect: r, polys: [rectPoly(r)] };
    if (ci && ci[2] > 1) return { circle: ci, polys: [circlePoly(ci[0], ci[1], ci[2], 180)] };
    p = cleanPoly(c.pts || c.points || c.poly || (typeof c.length === "number" ? c : null));
    return p ? { polys: [p] } : null;
  }
  function topOf(t) {
    if (!t || typeof t !== "object") return null;
    var r = arr(t.rect, 4) || (typeof t.length === "number" ? arr(t, 4) : null),
      c = arr(t.circle, 3) || (str(t.type) === "circle" ? arr([t.cx, t.cy, t.r], 3) : null);
    if (r && r[2] > 1 && r[3] > 1) return { r: r };
    if (c && c[2] > 1) return { c: c };
    return null;
  }
  function tableOf(t, fam) {
    t = t && typeof t === "object" ? t : {};
    var round = str(t.shape) === "round" || (t.diameter !== undefined && t.length === undefined) ||
      (fam === "round" && t.length === undefined), H = num(t.height, 8, 72) || 30;
    if (round) return { round: true, d: num(t.diameter, 8, 144) || 30, h: H };
    return { round: false, l: num(t.length, 12, 240) || 72, dp: num(t.depth, 8, 96) || 30, h: H };
  }
  // A plausible template when the specs leave something out (1.25 in bleed, drops to about 3 in off the floor).
  function defaults(fam, tb, sides) {
    var bl = 1.25, drop, w, h, top, R, c, cr, back;
    if (fam === "round") {
      R = (tb.round ? tb.d : Math.min(tb.l, tb.dp)) / 2; drop = tb.h - 2; c = R + drop + bl;
      return { tpl: { w: 2 * c, h: 2 * c }, top: { c: [c, c, R] }, cut: { circle: [c, c, R + drop], polys: [circlePoly(c, c, R + drop, 180)] } };
    }
    var L = tb.round ? tb.d : tb.l, D = tb.round ? tb.d : tb.dp;
    if (fam === "runner") { drop = tb.h - 3; w = 24 + 2 * bl; h = D + 2 * drop + 2 * bl; top = [bl, bl + drop, 24, D]; }
    else {
      drop = fam === "throw" ? tb.h - 3 : tb.h - 1; back = sides === 3 ? 0 : drop;
      w = L + 2 * drop + 2 * bl; h = D + drop + back + 2 * bl; top = [bl + drop, bl + back, L, D];
    }
    cr = [bl, bl, w - 2 * bl, h - 2 * bl];
    return { tpl: { w: w, h: h }, top: { r: top }, cut: { rect: cr, polys: [rectPoly(cr)] } };
  }
  function normalize(o) {
    var key = keyOf(o.key), tb0 = o.table && typeof o.table === "object" ? o.table : null,
      fam = famOf(o.family, key) || (tb0 && str(tb0.shape) === "round" ? "round" : "throw"),
      sides = sidesOf(o.sides, key) || 4, tb = tableOf(tb0, fam), d = defaults(fam, tb, sides),
      tw = o.tpl ? num(o.tpl.w, 4, 600) : null, th = o.tpl ? num(o.tpl.h, 4, 600) : null,
      tpl = tw && th ? { w: tw, h: th } : d.tpl, cut = cutOf(o.cut, 0) || (tw && th ? null : d.cut),
      top = topOf(o.top) || d.top;
    if (!cut) cut = { rect: [0, 0, tpl.w, tpl.h], polys: [rectPoly([0, 0, tpl.w, tpl.h])] };
    if (fam === "round" && !top.c) top = { c: [top.r[0] + top.r[2] / 2, top.r[1] + top.r[3] / 2, Math.min(top.r[2], top.r[3]) / 2] };
    if (fam !== "round" && !top.r) top = { r: [top.c[0] - top.c[2], top.c[1] - top.c[2], 2 * top.c[2], 2 * top.c[2]] };
    return { key: key, fam: fam, sides: sides, tb: tb, tpl: tpl, cut: cut, top: top, under: fam === "runner" ? colorOf(o.under) : null };
  }
  function hashPts(p) {
    var h = 0, i;
    for (i = 0; i < p.length; i++) h = (h * 31 + Math.round(p[i][0] * 997) * 7 + Math.round(p[i][1] * 991)) % 2147483647;
    return p.length + ":" + h;
  }

  /* ---------- 2D helpers (template inches, y down) ---------- */
  function area(p) {
    var a = 0, i, j;
    for (i = 0, j = p.length - 1; i < p.length; j = i++) a += p[j][0] * p[i][1] - p[i][0] * p[j][1];
    return a / 2;
  }
  function boxOf(p) {
    var b = [Infinity, Infinity, -Infinity, -Infinity], i;
    for (i = 0; i < p.length; i++) {
      b[0] = Math.min(b[0], p[i][0]); b[1] = Math.min(b[1], p[i][1]);
      b[2] = Math.max(b[2], p[i][0]); b[3] = Math.max(b[3], p[i][1]);
    }
    return b;
  }
  function clipRect(poly, x0, y0, x1, y1) {
    var out = poly, E = [[0, x0, 1], [0, x1, -1], [1, y0, 1], [1, y1, -1]], e, i;
    for (e = 0; e < 4 && out.length; e++) {
      var ax = E[e][0], v = E[e][1], sg = E[e][2], inp = out;
      out = [];
      for (i = 0; i < inp.length; i++) {
        var P = inp[i], Q = inp[(i + 1) % inp.length], pin = (P[ax] - v) * sg >= 0, qin = (Q[ax] - v) * sg >= 0;
        if (pin) out.push(P);
        if (pin !== qin) {
          var t = (v - P[ax]) / (Q[ax] - P[ax]);
          out.push([P[0] + (Q[0] - P[0]) * t, P[1] + (Q[1] - P[1]) * t]);
        }
      }
    }
    return out;
  }
  // distance from (cx, cy) along angle th to the polygon edge (farthest hit; polygons here are star-shaped)
  function rayDist(poly, cx, cy, th) {
    var dx = Math.cos(th), dy = Math.sin(th), best = 0, i, j;
    for (i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      var ax = poly[j][0] - cx, ay = poly[j][1] - cy, ex = poly[i][0] - poly[j][0], ey = poly[i][1] - poly[j][1],
        den = dx * ey - dy * ex;
      if (Math.abs(den) < 1e-12) continue;
      var t = (ax * ey - ay * ex) / den, s = (ax * dy - ay * dx) / den;
      if (s >= -1e-9 && s <= 1 + 1e-9 && t > best) best = t;
    }
    return best;
  }
  // the outer extent of the cut piece crossed by the line axis(ax) = val nearest to mid (ax 1: v = val, a u range);
  // openings inside a piece (an arched back) stay open
  function span(polys, ax, val, mid) {
    var best = null, i, j, k, p, xs, d;
    for (k = 0; k < polys.length; k++) {
      p = polys[k]; xs = [];
      for (i = 0, j = p.length - 1; i < p.length; j = i++) {
        var a = p[j][ax], b = p[i][ax];
        if ((a > val) !== (b > val)) xs.push(p[j][1 - ax] + (val - a) * (p[i][1 - ax] - p[j][1 - ax]) / (b - a));
      }
      if (xs.length < 2) continue;
      xs.sort(function (x, y) { return x - y; });
      i = xs.length - 1;
      d = mid < xs[0] ? xs[0] - mid : mid > xs[i] ? mid - xs[i] : 0;
      if (!best || d < best[2]) best = [xs[0], xs[i], d];
    }
    return best;
  }
  // grid lines: even spacing plus the table edges and the bend just past them
  function breaks(lo, hi, edges, La, cell) {
    var all = [], out = [], i, k, n = Math.max(1, Math.round((hi - lo) / cell));
    all.push([lo, 2], [hi, 2]);
    for (i = 0; i < edges.length; i++) {
      all.push([edges[i], 2]);
      for (k = 1; k <= 3; k++) all.push([edges[i] - La * k / 3, 1], [edges[i] + La * k / 3, 1]);
    }
    for (k = 1; k < n; k++) all.push([lo + (hi - lo) * k / n, 0]);
    all.sort(function (a, b) { return a[0] - b[0]; });
    for (i = 0; i < all.length; i++) {
      var x = all[i][0], pr = all[i][1], m = out.length;
      if (x < lo - 1e-9 || x > hi + 1e-9) continue;
      if (!m) { out.push(all[i]); continue; }
      var gap = x - out[m - 1][0], need = pr && out[m - 1][1] ? 0.02 : cell * 0.3;
      if (gap >= need) out.push(all[i]);
      else if (pr > out[m - 1][1]) out[m - 1] = all[i];
    }
    return out.map(function (e) { return e[0]; });
  }

  /* ---------- the drape: template point (u, v) -> 3D point ---------- */
  // Fabric hanging over a table edge: a small round-over, then down with a slight outward flare.
  function hanger(P) {
    return function (s) {
      var re = P.re, La = re * PI / 2;
      if (s <= La) return [re * Math.sin(s / re), re * (1 - Math.cos(s / re))];
      var q = s - La, f = P.flare * q / (q + 10);
      return [re + f * q, re + q * (1 - 0.5 * f * f)];
    };
  }
  // The template's top area is laid onto the real table top (fold lines can be an inch or so off the table size).
  function fitTop(C) {
    var tb = C.tb, c = C.top.c, r = C.top.r;
    function fit(t, T) { return Math.max(0.9 * T, Math.min(1.1 * T, t)); }
    if (c) return [fit((tb.round ? tb.d : Math.min(tb.l, tb.dp)) / 2, c[2])];
    if (C.fam === "runner") return [r[2] / 2, fit((tb.round ? tb.d : tb.dp) / 2, r[3] / 2)];
    return [fit((tb.round ? tb.d : tb.l) / 2, r[2] / 2), fit((tb.round ? tb.d : tb.dp) / 2, r[3] / 2)];
  }
  function rectDrape(C, P) {
    var r = C.top.r, cu = r[0] + r[2] / 2, cv = r[1] + r[3] / 2, Tx = r[2] / 2, Tz = r[3] / 2, Y0 = P.y0,
      ft = fitTop(C), hx = ft[0], hz = ft[1], kx = hx / Tx, kz = hz / Tz,
      maxDown = Y0 - FLOOR, hang = hanger(P), E = 1e-7, polys = C.cut.polys, bc = boxOf([].concat.apply([], polys)),
      lens = [cu - Tx - bc[0], bc[2] - cu - Tx, cv - Tz - bc[1], bc[3] - cv - Tz]; // drop lengths: left, right, back, front
    // sewn box (fitted, stretch): each drop row spans corner to corner, whatever its piece's outline
    function spanAt(ax, val, mid, c, T) {
      var s = span(polys, ax, val + (val > (ax ? cv : cu) ? -1e-4 : 1e-4), mid) || [c - T, c + T],
        lo = s[0] < c - T - 0.75 ? c - T : s[0], hi = s[1] > c + T + 0.75 ? c + T : s[1];
      return hi - lo > 1 ? [lo, hi] : [c - T, c + T];
    }
    return function (u, v, out) {
      var px = u - cu, pz = v - cv, sx = px < 0 ? -1 : 1, sz = pz < 0 ? -1 : 1,
        a = Math.abs(px) - Tx, b = Math.abs(pz) - Tz, h, o, dn, x, z, edge, sp;
      if (a <= E && b <= E) { out[0] = px * kx; out[1] = Y0; out[2] = pz * kz; return; }
      if (a > E && b > E && P.ear) {
        // loose corner: depth = distance from the table corner (rounded corners keep the hem level); the
        // spare cloth folds into a soft pleat that sticks out on the diagonal
        var s = Math.sqrt(a * a + b * b), th = Math.atan2(a, b), w = s * Math.min(th, PI / 2 - th), wf = w / (s * PI / 4),
          rc, Lc, l = w * P.ear, p, q, t;
        h = hang(s); o = h[0]; dn = h[1];
        rc = Math.max(0.3, 1.25 * o); Lc = rc * PI / 4;
        if (l <= Lc) { t = l / rc - PI / 4; p = -o * S2 + rc * (Math.sin(t) + S2); q = o * S2 - rc * (Math.cos(t) - S2); }
        else { p = -o * S2 + rc * S2 + (l - Lc); q = o * S2 - rc * (1 - S2); }
        q = q * (1 - wf * wf * wf) + P.bulge * l * wf * (1 - wf);
        dn += P.sag * l * Math.pow(wf, 1.5);
        if (dn > maxDown) { p += (dn - maxDown) * 0.3; dn = maxDown; }
        if (a > b) q = -q;
        out[0] = sx * (hx + o) + (p - q) * sx * S2;
        out[1] = Y0 - dn;
        out[2] = sz * (hz + o) + (p + q) * sz * S2;
        return;
      }
      if (a > E && b > E) { if (a >= b) { pz = sz * Tz; b = 0; } else { px = sx * Tx; a = 0; } } // sewn corners: never drawn
      var s0 = b > E ? b : a, L0 = lens[b > E ? (sz > 0 ? 3 : 2) : (sx > 0 ? 1 : 0)];
      if (P.pull && L0 > maxDown - 0.6) s0 *= (maxDown - 0.6) / L0; // spandex is pulled taut down to the feet
      h = hang(s0); o = h[0]; dn = h[1];
      if (dn > maxDown) { o += (dn - maxDown) * 0.55; dn = maxDown; }
      if (b > E) {
        x = px * kx; z = sz * (hz + o); edge = px / Tx;
        if (P.box) { sp = spanAt(1, v, u, cu, Tx); x = ((u - sp[0]) / (sp[1] - sp[0]) * 2 - 1) * (hx + o); }
      } else {
        x = sx * (hx + o); z = pz * kz; edge = pz / Tz;
        if (P.box) { sp = spanAt(0, u, v, cv, Tz); z = ((v - sp[0]) / (sp[1] - sp[0]) * 2 - 1) * (hz + o); }
      }
      var y = Y0 - dn;
      if (P.pull) { // spandex: pulled in toward the leg feet, hem lifted between them
        t = Math.min(1, dn / maxDown); t = t * t * (3 - 2 * t);
        x *= 1 + (P.fx / (hx + P.re) - 1) * t;
        z *= 1 + (P.fz / (hz + P.re) - 1) * t;
        y += P.arch * t * (1 - edge * edge) * (b > E ? 1 : 0.6);
      }
      out[0] = x; out[1] = y; out[2] = z;
    };
  }
  // Round covers: each ring of hanging cloth forms n rounded folds between creases near the table edge
  // (circular arcs; when an arc would pass a half circle the fold deepens into a pipe: straight walls and a
  // round crest). Every fold keeps the fabric's true length, so the print is not squeezed; a crest faces each side.
  function roundDrape(C, P) {
    var c = C.top.c, cx = c[0], cy = c[1], R = c[2], R3 = fitTop(C)[0], k3 = R3 / R, Y0 = P.y0, maxDown = Y0 - FLOOR, hang = hanger(P),
      n = P.n, per = 2 * PI / n, sh = Math.sin(per / 2), ch = Math.cos(per / 2);
    function ring(s) {
      var h = hang(s), rc = R3 + h[0], dn = h[1], Lp = (R3 + s) * per, chord, Q, lo = 0, hi = PI, al, it, D = 0;
      if (dn > maxDown) { rc += (dn - maxDown) * 0.5; dn = maxDown; }
      chord = 2 * rc * sh; Q = Lp / chord;
      if (Q >= PI / 2) { al = PI; D = (Lp - PI * chord / 2) / 2; } // a deep pipe fold
      else if (Q <= 1 + 1e-9) al = 0;
      else {
        for (it = 0; it < 36; it++) { al = (lo + hi) / 2; if (al / (2 * Math.sin(al / 2)) < Q) lo = al; else hi = al; }
        al = (lo + hi) / 2;
      }
      return [rc, dn, al, chord, D];
    }
    return function (u, v, out) {
      var dx = u - cx, dz = v - cy, r = Math.sqrt(dx * dx + dz * dz);
      if (r <= R + 1e-7) { out[0] = dx * k3; out[1] = Y0; out[2] = dz * k3; return; }
      var g = ring(r - R), d = Math.atan2(dz, dx) - PI / 2, m = Math.floor(d / per + 0.5), f = d / per - m,
        mid = PI / 2 + m * per, pr, pt, rp, b;
      if (g[2] < 1e-5) { pr = g[0] * ch; pt = f * g[3]; }
      else if (g[4] > 0) { // pipe: wall out, half circle round the crest, wall back
        var D = g[4], hc = g[3] / 2, l = (f + 0.5) * (2 * D + PI * hc), base = g[0] * ch;
        if (l <= D) { pr = base + l; pt = -hc; }
        else if (l >= D + PI * hc) { pr = base + 2 * D + PI * hc - l; pt = hc; }
        else { b = (l - D) / hc; pr = base + D + hc * Math.sin(b); pt = -hc * Math.cos(b); }
      } else {
        rp = g[3] / (2 * Math.sin(g[2] / 2)); b = f * g[2];
        pr = g[0] * ch + rp * (Math.cos(b) - Math.cos(g[2] / 2)); pt = rp * Math.sin(b);
      }
      var cm = Math.cos(mid), sm = Math.sin(mid);
      out[0] = pr * cm - pt * sm; out[1] = Y0 - g[1]; out[2] = pr * sm + pt * cm;
    };
  }

  /* ---------- meshes over the template ---------- */
  function finishMesh(U, V, idx, drape, tpl) {
    var n = U.length, pos = new Float32Array(n * 3), uv = new Float32Array(n * 2), o = [0, 0, 0], i;
    for (i = 0; i < n; i++) {
      drape(U[i], V[i], o);
      pos[i * 3] = o[0]; pos[i * 3 + 1] = o[1]; pos[i * 3 + 2] = o[2];
      uv[i * 2] = U[i] / tpl.w; uv[i * 2 + 1] = 1 - V[i] / tpl.h;
    }
    return { pos: pos, uv: uv, idx: idx, n: n };
  }
  function addTri(U, V, idx, a, b, c) { // printed side out: clockwise on the template (v down)
    var A2 = (U[b] - U[a]) * (V[c] - V[a]) - (V[b] - V[a]) * (U[c] - U[a]);
    if (Math.abs(A2) < 1e-9) return;
    if (A2 > 0) idx.push(a, c, b); else idx.push(a, b, c);
  }
  function gridMesh(THREE, C, P, drape) {
    var polys = C.cut.polys, rect = C.cut.rect, bb = boxOf([].concat.apply([], polys)), tr = C.top.r, La = P.re * PI / 2,
      cu = tr[0] + tr[2] / 2, cv = tr[1] + tr[3] / 2, Tx = tr[2] / 2, Tz = tr[3] / 2,
      xs = breaks(bb[0], bb[2], [tr[0], tr[0] + tr[2]], La, P.cell), ys = breaks(bb[1], bb[3], [tr[1], tr[1] + tr[3]], La, P.cell),
      map = {}, U = [], V = [], idx = [], i, j, k;
    function vid(u, v) {
      var key = Math.round(u * 256) + "_" + Math.round(v * 256), e = map[key];
      if (e === undefined) { e = map[key] = U.length; U.push(u); V.push(v); }
      return e;
    }
    function corner(u, v) { return Math.abs(u - cu) - Tx > 1e-4 && Math.abs(v - cv) - Tz > 1e-4; }
    for (j = 0; j < ys.length - 1; j++) for (i = 0; i < xs.length - 1; i++) {
      var x0 = xs[i], x1 = xs[i + 1], y0 = ys[j], y1 = ys[j + 1], ca = (x1 - x0) * (y1 - y0);
      if (P.noCorners && corner((x0 + x1) / 2, (y0 + y1) / 2)) continue;
      if (!rect) { // clip the cell by each cut piece
        var parts = [], tot = 0, m, cp, ar;
        for (m = 0; m < polys.length; m++) {
          cp = clipRect(polys[m], x0, y0, x1, y1); ar = cp.length >= 3 ? Math.abs(area(cp)) : 0;
          if (ar >= ca * 1e-4) { parts.push(cp); tot += ar; }
        }
        if (!parts.length) continue;
        if (parts.length > 1 || tot < ca * 0.9995) {
          for (m = 0; m < parts.length; m++) {
            var v2 = [], ids = [], tri;
            cp = parts[m];
            for (k = 0; k < cp.length; k++) { v2.push(new THREE.Vector2(cp[k][0], cp[k][1])); ids.push(vid(cp[k][0], cp[k][1])); }
            tri = THREE.ShapeUtils.triangulateShape(v2, []);
            for (k = 0; k < tri.length; k++) addTri(U, V, idx, ids[tri[k][0]], ids[tri[k][1]], ids[tri[k][2]]);
          }
          continue;
        }
      }
      var a = vid(x0, y0), b = vid(x1, y0), c = vid(x1, y1), d = vid(x0, y1);
      addTri(U, V, idx, a, b, c); addTri(U, V, idx, a, c, d);
    }
    return finishMesh(U, V, idx, drape, C.tpl);
  }
  function polarMesh(C, P, drape) {
    var c = C.top.c, cx = c[0], cy = c[1], R = c[2], polys = C.cut.polys, nA = P.seg, La = P.re * PI / 2,
      U = [cx], V = [cy], idx = [], rmax = [], ang = [], rings = [], i, j, S = 0, rr;
    for (i = 0; i < nA; i++) {
      ang.push(2 * PI * i / nA);
      for (j = 0, rr = 0; j < polys.length; j++) rr = Math.max(rr, rayDist(polys[j], cx, cy, ang[i]));
      rmax.push(rr);
      S = Math.max(S, rmax[i] - R);
    }
    for (j = 1; j <= 10; j++) rings.push(R * j / 10);
    for (j = 1; j <= 3; j++) rings.push(R + La * j / 3);
    var nH = Math.max(1, Math.ceil((S - La) / P.cell));
    for (j = 1; j <= nH; j++) rings.push(R + La + (S - La) * j / nH);
    for (j = 0; j < rings.length; j++) for (i = 0; i < nA; i++) {
      rr = Math.min(rings[j], rmax[i]);
      U.push(cx + rr * Math.cos(ang[i])); V.push(cy + rr * Math.sin(ang[i]));
    }
    for (i = 0; i < nA; i++) addTri(U, V, idx, 0, 1 + i, 1 + (i + 1) % nA);
    for (j = 0; j < rings.length - 1; j++) for (i = 0; i < nA; i++) {
      var a = 1 + j * nA + i, b = 1 + j * nA + (i + 1) % nA, d = a + nA, e = b + nA;
      addTri(U, V, idx, a, b, e); addTri(U, V, idx, a, e, d);
    }
    return finishMesh(U, V, idx, drape, C.tpl);
  }
  // drape settings per cover type
  function params(C, legs) {
    var tb = C.tb, H = tb.h, fam = C.fam, P = { y0: H + 0.05, re: 0.6, flare: 0.05, cell: 1.25 };
    if (fam === "throw") { P.ear = 0.3; P.sag = 0.35; P.bulge = 0.45; }
    else if (fam === "fitted") { P.re = 0.32; P.flare = 0; P.box = true; P.noCorners = true; P.cell = 1.6; }
    else if (fam === "stretch") {
      P.re = 0.4; P.flare = 0; P.box = true; P.noCorners = true; P.pull = true; P.cell = 1.6;
      P.fx = legs[0] + 1.4; P.fz = legs[1] + 1.4; P.arch = Math.min(2.2, 0.075 * H);
    }
    else if (fam === "runner") {
      P.flare = 0.035;
      if (C.under) { P.y0 += 0.12; P.re = 0.76; P.flare = 0.056; }
    }
    else if (fam === "round") {
      var R = C.top.c[2];
      P.flare = 0.06; P.cell = 1; P.seg = 240;
      P.n = 4 * Math.max(2, Math.round(2 * PI * R / 18 / 4));
    }
    return P;
  }

  /* ---------- viewer ---------- */
  function rng(seed) { return function () { seed = seed * 16807 % 2147483647; return seed / 2147483647; }; }

  function build(host, opts) {
    var THREE = root.THREE, doc = host.ownerDocument || document, win = doc.defaultView || root,
      bg = bgColor(opts.background), canvas = doc.createElement("canvas");
    canvas.setAttribute("aria-label", "3D preview of your table cover. Drag to turn it.");
    canvas.setAttribute("data-ardor-table3d", "init");
    canvas.style.cssText = "position:absolute;top:0;left:0;right:0;bottom:0;inset:0;width:100%;height:100%;display:block;touch-action:none;outline:none;cursor:grab;";
    var attrs = { alpha: false, antialias: true, depth: true, stencil: false, premultipliedAlpha: true, preserveDrawingBuffer: false },
      gl = null;
    try { gl = canvas.getContext("webgl2", attrs); } catch (e1) { gl = null; }
    if (!gl) try { gl = canvas.getContext("webgl", attrs) || canvas.getContext("experimental-webgl", attrs); } catch (e2) { gl = null; }
    if (!gl) return null;
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, context: gl, antialias: true, alpha: false, stencil: false, preserveDrawingBuffer: false });
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.NoToneMapping;
    renderer.setClearColor(new THREE.Color(bg), 1);
    try { if (win.getComputedStyle && win.getComputedStyle(host).position === "static") host.style.position = "relative"; } catch (e3) { }
    host.appendChild(canvas);

    var maxAniso = 1;
    try { maxAniso = renderer.capabilities.getMaxAnisotropy() || 1; } catch (e4) { maxAniso = 1; }
    var canMip = !!renderer.capabilities.isWebGL2, scene = new THREE.Scene(),
      camera = new THREE.PerspectiveCamera(FOV, 1, 1, 4000), disposed = false;
    scene.add(camera);

    function lin(hex) { var c = new THREE.Color(hex); c.convertSRGBToLinear(); return c; }
    // lights: soft sky/ground fill, a light that follows the camera (so every side reads), a fixed key and back fill
    var hemi = new THREE.HemisphereLight(lin("#ffffff"), lin("#c9c4ba"), 0.46);
    hemi.position.set(0, 1, 0);
    scene.add(hemi);
    var head = new THREE.DirectionalLight(0xffffff, 0.34);
    head.position.set(-0.3, 0.5, 1);
    camera.add(head); camera.add(head.target);
    var SUN = [-0.32, 1, 0.42], key = new THREE.DirectionalLight(0xffffff, 0.36), fill = new THREE.DirectionalLight(0xffffff, 0.26);
    key.position.set(-0.45, 0.55, 0.7); fill.position.set(0.4, 0.5, -0.75);
    scene.add(key); scene.add(fill);

    /* materials (kept for the life of the viewer) */
    var coverMat = new THREE.MeshLambertMaterial({ color: 0xffffff, side: THREE.FrontSide });
    coverMat.onBeforeCompile = function (sh) { // transparent print pixels read as white fabric
      sh.fragmentShader = sh.fragmentShader.replace("#include <map_fragment>", ["#ifdef USE_MAP",
        "  vec4 tc = texture2D( map, vUv );", "  tc.rgb = mix( vec3( 1.0 ), tc.rgb, tc.a );",
        "  diffuseColor.rgb *= tc.rgb;", "#endif"].join("\n"));
    };
    coverMat.customProgramCacheKey = function () { return "ardorTableCover"; };
    function lam(hex, side) { return new THREE.MeshLambertMaterial({ color: lin(hex), side: side || THREE.FrontSide }); }
    function metal(hex, shin) { return new THREE.MeshPhongMaterial({ color: lin(hex), specular: lin("#4a4f55"), shininess: shin || 50 }); }
    var M = {
      back: lam("#e6e5e0", THREE.BackSide), under: lam("#ffffff"), top: lam("#d6d6d0"), topEdge: lam("#c4c5c0"),
      frame: metal("#5d6268", 40), foot: lam("#1e2023")
    };
    var groundMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, depthWrite: false, toneMapped: false });

    function plainTexture(c) {
      var t = new THREE.CanvasTexture(c);
      t.encoding = THREE.sRGBEncoding;
      t.anisotropy = maxAniso;
      t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
      t.magFilter = THREE.LinearFilter;
      t.minFilter = canMip ? THREE.LinearMipmapLinearFilter : THREE.LinearFilter;
      t.generateMipmaps = canMip;
      return t;
    }
    var groundCv = doc.createElement("canvas");
    groundCv.width = groundCv.height = 1024;
    var groundTex = plainTexture(groundCv);
    groundMat.map = groundTex;

    var tex = { src: null, t: null, w: 0, h: 0 }, input = {}, C = null, builtKey = "", underColor = "",
      coverRoot = null, geos = [], info = {}, ground = null, ptsAll = [], ptsNear = [], cAll = new THREE.Vector3(),
      target = new THREE.Vector3(0, 20, 0), fitHome = 300, size = { w: 0, h: 0 }, coverN = 0;

    function bindTexture() {
      var had = !!coverMat.map;
      coverMat.map = tex.t || null;
      if (had !== !!coverMat.map) coverMat.needsUpdate = true;
    }
    function applyTexture() {
      var src = tex.src;
      if (!src || !(src.width > 0) || !(src.height > 0)) {
        if (tex.t) tex.t.dispose();
        tex.t = null; tex.w = tex.h = 0;
      } else if (tex.t && tex.t.image === src && tex.w === src.width && tex.h === src.height) {
        tex.t.needsUpdate = true;
      } else {
        if (tex.t) tex.t.dispose();
        tex.t = plainTexture(src); tex.w = src.width; tex.h = src.height;
      }
      bindTexture();
    }

    var controls = new THREE.OrbitControls(camera, canvas);
    controls.enablePan = false;
    controls.enableDamping = true;
    controls.dampingFactor = 0.12;
    controls.rotateSpeed = 0.8;
    controls.zoomSpeed = 0.9;
    controls.minPolarAngle = PI / 2 - EL_MAX;
    controls.maxPolarAngle = PI / 2 - EL_MIN;

    /* ---------- model building ---------- */
    function addTo(group, geo, mat, x, y, z) {
      var m = new THREE.Mesh(geo, mat);
      m.position.set(x || 0, y || 0, z || 0);
      group.add(m); geos.push(geo);
      return m;
    }
    function boxAt(G, mat, w, h, d, x, y, z) { return addTo(G, new THREE.BoxGeometry(w, h, d), mat, x, y, z); }
    function cylAt(G, mat, r0, r1, y0, y1, x, z, seg) {
      return addTo(G, new THREE.CylinderGeometry(r1, r0, y1 - y0, seg || 16), mat, x, (y0 + y1) / 2, z);
    }
    function rod(G, mat, r, a, b) { // a thin cylinder from point a to point b
      var va = new THREE.Vector3(a[0], a[1], a[2]), vb = new THREE.Vector3(b[0], b[1], b[2]),
        m = addTo(G, new THREE.CylinderGeometry(r, r, va.distanceTo(vb), 10), mat);
      m.position.copy(va).add(vb).multiplyScalar(0.5);
      m.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), vb.sub(va).normalize());
      return m;
    }
    function disposeGeos() { for (var i = 0; i < geos.length; i++) try { geos[i].dispose(); } catch (e) { } geos.length = 0; }

    // a plain folding table (rect: two folding leg frames; round: 4 legs, or a pedestal at bar height)
    function tableSize() {
      var tb = C.tb, ft = fitTop(C);
      if (C.fam === "round") return { round: true, r: ft[0] - 0.06 };
      if (tb.round) return { round: true, r: tb.d / 2 - 0.06 };
      return { round: false, bx: (C.fam === "runner" ? tb.l / 2 : ft[0]) - 0.06, bz: ft[1] - 0.06 };
    }
    function legSpots(ts) {
      if (ts.round) return [ts.r * 0.6 * S2, ts.r * 0.6 * S2];
      return [Math.max(2, ts.bx - 5.5), Math.max(1.5, ts.bz - 2.2)];
    }
    function buildTable(G, ts) {
      var H = C.tb.h, yb = H - BOARD, legs = [], i, k;
      if (ts.round) {
        var R = ts.r;
        cylAt(G, M.top, R, R, yb, H, 0, 0, 72);
        if (H >= 36) { // bar height: pedestal
          var br = Math.min(12, Math.max(6, 0.8 * R));
          cylAt(G, M.frame, Math.min(7, R * 0.5), Math.min(7, R * 0.5), yb - 0.5, yb, 0, 0, 28);
          cylAt(G, M.frame, 1.5, 1.5, 0.9, yb - 0.5, 0, 0, 20);
          cylAt(G, M.frame, br + 0.3, br, 0, 0.9, 0, 0, 44);
          legs.push([0, 0, br]);
        } else {
          var lr = legSpots(ts);
          for (k = 0; k < 4; k++) {
            var lx = (k & 1 ? 1 : -1) * lr[0], lz = (k & 2 ? 1 : -1) * lr[1];
            rod(G, M.frame, 0.55, [lx, 0.6, lz], [lx, yb - 0.3, lz]);
            cylAt(G, M.foot, 0.85, 0.85, 0, 0.7, lx, lz, 12);
            legs.push([lx, lz, 1]);
          }
          for (k = -1; k <= 1; k += 2) {
            rod(G, M.frame, 0.4, [k * lr[0], yb - 1.2, -lr[1]], [k * lr[0], yb - 1.2, lr[1]]);
            rod(G, M.frame, 0.4, [k * lr[0], 7, -lr[1]], [k * lr[0], 7, lr[1]]);
          }
        }
      } else {
        var bx = ts.bx, bz = ts.bz, ls = legSpots(ts), ly = yb - 0.4;
        boxAt(G, M.top, 2 * bx, BOARD, 2 * bz, 0, H - BOARD / 2, 0);
        boxAt(G, M.frame, 2 * bx - 2.4, 1, 1, 0, yb - 0.5, bz - 1.3);
        boxAt(G, M.frame, 2 * bx - 2.4, 1, 1, 0, yb - 0.5, -(bz - 1.3));
        boxAt(G, M.frame, 1, 1, 2 * bz - 2.6, bx - 1.3, yb - 0.5, 0);
        boxAt(G, M.frame, 1, 1, 2 * bz - 2.6, -(bx - 1.3), yb - 0.5, 0);
        for (i = -1; i <= 1; i += 2) {
          var x = i * ls[0];
          for (k = -1; k <= 1; k += 2) {
            rod(G, M.frame, 0.55, [x, 0.6, k * ls[1]], [x, ly, k * ls[1]]);
            cylAt(G, M.foot, 0.85, 0.85, 0, 0.7, x, k * ls[1], 12);
            legs.push([x, k * ls[1], 1]);
          }
          rod(G, M.frame, 0.42, [x, ly - 0.6, -ls[1]], [x, ly - 0.6, ls[1]]);
          rod(G, M.frame, 0.42, [x, 6.5, -ls[1]], [x, 6.5, ls[1]]);
          rod(G, M.frame, 0.38, [x, 6.5, 0], [x - i * Math.min(16, bx * 0.45), yb - 0.9, 0]);
        }
      }
      return legs;
    }

    function addCloth(G, mesh, frontMat) {
      var geo = new THREE.BufferGeometry();
      geo.setAttribute("position", new THREE.BufferAttribute(mesh.pos, 3));
      geo.setAttribute("uv", new THREE.BufferAttribute(mesh.uv, 2));
      geo.setIndex(mesh.n > 65000 ? new THREE.Uint32BufferAttribute(mesh.idx, 1) : new THREE.Uint16BufferAttribute(mesh.idx, 1));
      geo.computeVertexNormals();
      addTo(G, geo, frontMat);
      G.add(new THREE.Mesh(geo, M.back));
      return geo;
    }
    function measureCloth(mesh, b, foot) {
      var p = mesh.pos, i;
      for (i = 0; i < mesh.n; i++) {
        var x = p[i * 3], y = p[i * 3 + 1], z = p[i * 3 + 2];
        b[0] = Math.min(b[0], x); b[1] = Math.max(b[1], y); b[2] = Math.min(b[2], z);
        b[3] = Math.max(b[3], x); b[4] = Math.max(b[4], z); b[5] = Math.min(b[5], y);
        if (y < 9) {
          foot[0] = Math.min(foot[0], x); foot[1] = Math.min(foot[1], z); foot[2] = Math.max(foot[2], x); foot[3] = Math.max(foot[3], z);
          foot[4] = Math.max(foot[4], Math.sqrt(x * x + z * z));
        }
      }
    }

    function buildAll() {
      if (coverRoot) { scene.remove(coverRoot); disposeGeos(); }
      coverRoot = new THREE.Group();
      scene.add(coverRoot);
      var ts = tableSize(), legs = buildTable(coverRoot, ts), P = params(C, legSpots(ts)), mesh,
        b = [Infinity, -Infinity, Infinity, -Infinity, -Infinity, Infinity], foot = [Infinity, Infinity, -Infinity, -Infinity, 0];
      mesh = C.fam === "round" ? polarMesh(C, P, roundDrape(C, P)) : gridMesh(THREE, C, P, rectDrape(C, P));
      addCloth(coverRoot, mesh, coverMat);
      coverN = mesh.n;
      measureCloth(mesh, b, foot);
      if (C.fam === "runner" && C.under) { // the plain loose throw under a runner (4 sided)
        // stock 4 sided solid throw (6 ft 132 x 90 in, 8 ft 156 x 90 in: drops reach the floor), rounded corners
        var tb = C.tb, L = tb.round ? tb.d : tb.l, D = tb.round ? tb.d : tb.dp, drop = Math.max(4, Math.min(30, tb.h)),
          UC = { fam: "throw", tb: tb, tpl: { w: L + 2 * drop, h: D + 2 * drop }, top: { r: [drop, drop, L, D] } }, up = [], k2, j2;
        for (k2 = 0; k2 < 4; k2++) for (j2 = 0; j2 <= 12; j2++) {
          var an = (k2 - 1 + j2 / 12) * PI / 2;
          up.push([drop + (k2 === 0 || k2 === 1 ? L : 0) + drop * Math.cos(an), drop + (k2 === 1 || k2 === 2 ? D : 0) + drop * Math.sin(an)]);
        }
        UC.cut = { polys: [up] };
        var UP = params(UC, legs), um = gridMesh(THREE, UC, UP, rectDrape(UC, UP));
        addCloth(coverRoot, um, M.under);
        measureCloth(um, b, foot);
      }
      // table extents for framing and shadows
      var H = C.tb.h, tx = ts.round ? ts.r : ts.bx, tz = ts.round ? ts.r : ts.bz;
      b[0] = Math.min(b[0], -tx); b[3] = Math.max(b[3], tx); b[2] = Math.min(b[2], -tz); b[4] = Math.max(b[4], tz);
      b[1] = Math.max(b[1], H);
      if (!isFinite(foot[0])) foot = [-tx, -tz, tx, tz, 0];
      info = { box: b, foot: foot, legs: legs, ts: ts, round: C.fam === "round", // legs show: bare table, open back or a high hem
        hem: C.fam === "runner" ? !C.under : C.sides === 3 && C.fam !== "round" || C.fam === "stretch" || b[5] > 6 };
      paintGround();
      var m = 3, X0 = b[0] - m, X1 = b[3] + m, Z0 = b[2] - m, Z1 = b[4] + m, Y1 = b[1] + 0.5;
      ptsAll = []; ptsNear = [];
      cAll.set((X0 + X1) / 2, Y1 * 0.47, (Z0 + Z1) / 2);
      for (var i = 0; i < 8; i++) {
        ptsAll.push(new THREE.Vector3(i & 1 ? X1 : X0, i & 2 ? Y1 : 0, i & 4 ? Z1 : Z0));
        ptsNear.push(new THREE.Vector3(cAll.x + (i & 1 ? 1 : -1) * (X1 - X0) * 0.17, cAll.y + (i & 2 ? 1 : -1) * Y1 * 0.17, cAll.z + (i & 4 ? 1 : -1) * (Z1 - Z0) * 0.17));
      }
      var big = Math.max(Y1, X1 - X0, Z1 - Z0);
      camera.near = Math.max(0.3, big / 200); camera.far = big * 30;
      camera.updateProjectionMatrix();
    }

    function paintGround() {
      var N = groundCv.width, g = groundCv.getContext("2d"), b = info.box, ft = info.foot,
        R = Math.max(b[3] - b[0], b[4] - b[2]) * 0.62 + 30, s = N / (2 * R), rnd = rng(11), i;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.globalCompositeOperation = "source-over";
      g.shadowColor = "rgba(0,0,0,0)"; g.shadowBlur = 0;
      g.clearRect(0, 0, N, N);
      g.fillStyle = "#dad8d3"; g.fillRect(0, 0, N, N);
      for (i = 0; i < 7000; i++) {
        g.fillStyle = rnd() > 0.5 ? "rgba(255,255,255,0.35)" : "rgba(90,88,84,0.14)";
        g.fillRect(rnd() * N, rnd() * N, 1 + rnd() * 1.5, 1 + rnd() * 1.5);
      }
      var OFF = N * 3, lx = SUN[0] / SUN[1] * 0.25, lz = SUN[2] / SUN[1] * 0.25;
      function P(X, Z, Y) { Y = Y || 0; return [N / 2 + (X - lx * Y) * s - OFF, N / 2 + (Z - lz * Y) * s]; }
      function shade(alpha, blur, draw) {
        g.save(); g.shadowColor = "rgba(24,24,20," + alpha + ")"; g.shadowBlur = Math.max(1, blur); g.shadowOffsetX = OFF;
        g.fillStyle = "#000"; g.beginPath(); draw(); g.fill(); g.restore();
      }
      function foot(grow, Y) {
        if (info.round) { var q = P(0, 0, Y); g.arc(q[0], q[1], (ft[4] + grow) * s, 0, PI * 2); return; }
        var a = P(ft[0] - grow, ft[1] - grow, Y), c = P(ft[2] + grow, ft[3] + grow, Y), rr = Math.min(6, (c[0] - a[0]) / 6, (c[1] - a[1]) / 6);
        g.moveTo(a[0] + rr, a[1]); g.arcTo(c[0], a[1], c[0], c[1], rr); g.arcTo(c[0], c[1], a[0], c[1], rr);
        g.arcTo(a[0], c[1], a[0], a[1], rr); g.arcTo(a[0], a[1], c[0], a[1], rr); g.closePath();
      }
      if (info.hem) { // bare table or open back: soft shadow of the top, and the feet
        var ts = info.ts;
        shade(0.2, 9 * s, function () {
          if (ts.round) { var q = P(0, 0, 30); g.arc(q[0], q[1], ts.r * s, 0, PI * 2); }
          else { var a = P(-ts.bx, -ts.bz, 30), c = P(ts.bx, ts.bz, 30); g.rect(a[0], a[1], c[0] - a[0], c[1] - a[1]); }
        });
        for (i = 0; i < info.legs.length; i++) {
          var L = info.legs[i];
          shade(0.35, 1.4 * s, function () { var q = P(L[0], L[1]); g.arc(q[0], q[1], (L[2] > 2 ? L[2] : 1.1) * s, 0, PI * 2); });
        }
      }
      if (C.fam !== "runner" || C.under) {
        shade(0.2, 12 * s, function () { foot(3, 6); });
        shade(0.3, 2.2 * s, function () { foot(0.4, 0); });
      }
      var fade = g.createRadialGradient(N / 2, N / 2, 0, N / 2, N / 2, N / 2);
      fade.addColorStop(0, "rgba(0,0,0,1)"); fade.addColorStop(0.5, "rgba(0,0,0,1)"); fade.addColorStop(0.76, "rgba(0,0,0,0.5)");
      fade.addColorStop(0.96, "rgba(0,0,0,0)"); fade.addColorStop(1, "rgba(0,0,0,0)");
      g.globalCompositeOperation = "destination-in"; g.fillStyle = fade; g.fillRect(0, 0, N, N);
      g.globalCompositeOperation = "source-over";
      groundTex.needsUpdate = true;
      if (!ground) {
        ground = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), groundMat);
        ground.rotation.x = -PI / 2; ground.renderOrder = -1;
        scene.add(ground);
      }
      ground.scale.set(R, R, 1);
      ground.position.y = 0.02;
    }

    /* ---------- camera ---------- */
    var raf = 0, tween = null, backupT = 0;
    function now() { return win.performance && win.performance.now ? win.performance.now() : Date.now(); }
    function invalidate() {
      if (disposed) return;
      if (!raf) raf = win.requestAnimationFrame(frame);
      // a background tab does not run animation frames: draw anyway a little later
      if (!backupT) backupT = win.setTimeout(function () { backupT = 0; if (raf) { win.cancelAnimationFrame(raf); raf = 0; frame(); } }, 250);
    }
    function draw() { try { renderer.render(scene, camera); } catch (e) { } }
    function frame() {
      raf = 0;
      if (disposed || (!size.w && !measure())) return;
      var moving = !!tween;
      if (tween) stepTween();
      controls.update();
      holdInView();
      draw();
      if (tween || moving) invalidate();
    }
    function getSph() {
      var ox = camera.position.x - target.x, oy = camera.position.y - target.y, oz = camera.position.z - target.z,
        r = Math.sqrt(ox * ox + oy * oy + oz * oz) || 1;
      return { az: Math.atan2(ox, oz), el: Math.asin(Math.max(-1, Math.min(1, oy / r))), r: r };
    }
    function setSph(az, el, r) {
      var ce = Math.cos(el);
      camera.position.set(target.x + r * ce * Math.sin(az), target.y + r * Math.sin(el), target.z + r * ce * Math.cos(az));
      camera.lookAt(target);
    }
    function fitDistance(az, el, aspect, share, pts, c) {
      var tv = Math.tan(FOV * PI / 360), th = tv * (aspect || 1), ce = Math.cos(el), se = Math.sin(el), sa = Math.sin(az),
        ca = Math.cos(az), m = 1 / (share || 1), best = 1, i, x, y, z, cx, cy, cz, d;
      for (i = 0; i < pts.length; i++) {
        x = pts[i].x - c.x; y = pts[i].y - c.y; z = pts[i].z - c.z;
        cx = x * ca - z * sa; cy = -x * se * sa + y * ce - z * se * ca; cz = x * ce * sa + y * se + z * ce * ca;
        d = cz + Math.max(Math.abs(cx) * m / th, Math.abs(cy) * m / tv);
        if (d > best) best = d;
      }
      return best;
    }
    function aspectNow() { return size.w > 0 && size.h > 0 ? size.w / size.h : 1.3; }
    function farFor(az, el, asp) { return fitDistance(az, el, asp || aspectNow(), FILL_HOME, ptsAll, cAll); }
    function nearFor(az, el, asp) { return Math.min(farFor(az, el, asp) * 0.9, fitDistance(az, el, asp || aspectNow(), FILL_NEAR, ptsNear, cAll)); }
    function place(az, el, r) {
      target.copy(cAll); controls.target.copy(target);
      setSph(az, el, r);
    }
    function viewOf(name) {
      var v = typeof name === "string" && VIEWS.hasOwnProperty(name) ? VIEWS[name] : VIEWS.home;
      return { az: v[0], el: v[1] };
    }
    function updateLimits() {
      var s = getSph(), h = viewOf("home");
      fitHome = farFor(h.az, h.el);
      controls.minDistance = nearFor(s.az, s.el);
      controls.maxDistance = Math.max(fitDistance(0, 0.1, aspectNow(), FILL_FAR, ptsAll, cAll), fitHome * 1.3);
    }
    function clampR(r, az, el) { return Math.max(nearFor(az, el), Math.min(controls.maxDistance, r)); }
    function holdInView() {
      var s = getSph(), near = nearFor(s.az, s.el);
      controls.minDistance = near;
      if (!tween && s.r < near - 0.01) setSph(s.az, s.el, near);
    }
    function stepTween() {
      var t = (now() - tween.t0) / tween.ms;
      if (t >= 1) t = 1;
      var k = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      place(tween.a.az + (tween.b.az - tween.a.az) * k, tween.a.el + (tween.b.el - tween.a.el) * k, tween.a.r + (tween.b.r - tween.a.r) * k);
      if (t >= 1) tween = null;
    }
    var reduced = false;
    try { reduced = !!(win.matchMedia && win.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e5) { reduced = false; }
    function tweenTo(az, el, r, ms) {
      var a = getSph(), d = az - a.az;
      while (d > PI) d -= PI * 2;
      while (d < -PI) d += PI * 2;
      tween = { a: a, b: { az: a.az + d, el: el, r: r }, t0: now(), ms: reduced ? 1 : ms };
      invalidate();
    }
    function measure() {
      var w = host.clientWidth | 0, h = host.clientHeight | 0;
      if (w < 2 || h < 2) return false;
      var pr = Math.min(2, Math.max(1, win.devicePixelRatio || 1));
      if (w === size.w && h === size.h && pr === renderer.getPixelRatio()) return false;
      var oldFit = fitHome, had = size.w > 0;
      size.w = w; size.h = h;
      renderer.setPixelRatio(pr); renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      updateLimits();
      var s = getSph();
      if (had && !tween) place(s.az, s.el, clampR(s.r * fitHome / oldFit, s.az, s.el));
      else if (had && tween) tween.b.r = tween.b.r * fitHome / oldFit;
      else { var hv = viewOf("home"); place(hv.az, hv.el, fitHome); }
      controls.update();
      return true;
    }
    function onControlsChange() { invalidate(); }
    function onControlsStart() { tween = null; canvas.style.cursor = "grabbing"; }
    function onControlsEnd() { canvas.style.cursor = "grab"; }
    controls.addEventListener("change", onControlsChange);
    controls.addEventListener("start", onControlsStart);
    controls.addEventListener("end", onControlsEnd);

    function geoKey(c) {
      return [c.key, c.fam, c.sides, JSON.stringify(c.tb), c.tpl.w, c.tpl.h, c.cut.polys.map(hashPts).join(","), JSON.stringify(c.top), c.under ? 1 : 0].join("|");
    }
    var FIELDS = ["key", "family", "table", "tpl", "cut", "top", "sides", "under"];

    var api = {
      set: function (o) {
        if (disposed || !o || typeof o !== "object") return;
        var k, oldFit = fitHome, s = getSph(), first = !builtKey;
        if ((o.key !== undefined && keyOf(o.key) !== keyOf(input.key)) || (o.family !== undefined && str(o.family) !== str(input.family))) {
          for (k = 2; k < 7; k++) if (o[FIELDS[k]] === undefined) delete input[FIELDS[k]];
        }
        for (k = 0; k < FIELDS.length; k++) if (o[FIELDS[k]] !== undefined) input[FIELDS[k]] = o[FIELDS[k]];
        C = normalize(input);
        var gk = geoKey(C);
        if (gk !== builtKey) {
          buildAll(); builtKey = gk;
          updateLimits();
          if (first) { var hv = viewOf("home"); place(hv.az, hv.el, fitHome); }
          else {
            if (tween) tween.b.r = tween.b.r * fitHome / oldFit;
            place(s.az, s.el, clampR(s.r * fitHome / oldFit, s.az, s.el));
          }
          controls.update();
        }
        if ((C.under || "") !== underColor) { underColor = C.under || ""; if (C.under) M.under.color.copy(lin(C.under)); }
        invalidate();
      },
      setTexture: function (cv) {
        if (disposed) return;
        tex.src = cv && cv.width > 0 && cv.height > 0 ? cv : null;
        applyTexture(); invalidate();
      },
      refresh: function () {
        if (disposed) return;
        if (tex.src && (tex.src.width !== tex.w || tex.src.height !== tex.h || !tex.t)) applyTexture();
        else if (tex.t) tex.t.needsUpdate = true;
        invalidate();
      },
      view: function (name) {
        if (disposed) return;
        var v = viewOf(name);
        tweenTo(v.az, v.el, farFor(v.az, v.el), 560);
      },
      zoom: function (dir) {
        if (disposed) return;
        var s = tween ? tween.b : getSph(), r = clampR(s.r * Math.pow(0.8, dir > 0 ? 1 : -1), s.az, s.el);
        tweenTo(s.az, s.el, r, 240);
      },
      resize: function () {
        if (disposed) return;
        if (measure()) { if (raf) { win.cancelAnimationFrame(raf); raf = 0; } draw(); invalidate(); }
      },
      snapshot: function (w, h, viewName) {
        if (disposed) return null;
        var out = null, oldPR = renderer.getPixelRatio(), oldSize = renderer.getSize(new THREE.Vector2()), oldAspect = camera.aspect,
          oldPos = camera.position.clone(), oldTarget = target.clone(), s = getSph();
        try {
          var cap = Math.min(4096, renderer.capabilities.maxTextureSize || 4096);
          w = Math.max(16, Math.min(cap, Math.round(w || size.w || 800)));
          h = Math.max(16, Math.min(cap, Math.round(h || size.h || 600)));
          renderer.setPixelRatio(1); renderer.setSize(w, h, false);
          camera.aspect = w / h; camera.updateProjectionMatrix();
          if (typeof viewName === "string" && VIEWS.hasOwnProperty(viewName)) {
            var v = viewOf(viewName);
            place(v.az, v.el, farFor(v.az, v.el, w / h));
          } else {
            place(s.az, s.el, s.r * farFor(s.az, s.el, w / h) / farFor(s.az, s.el, oldAspect || 1));
          }
          renderer.render(scene, camera);
          out = doc.createElement("canvas"); out.width = w; out.height = h;
          var ctx = out.getContext("2d");
          ctx.fillStyle = bg; ctx.fillRect(0, 0, w, h); ctx.drawImage(canvas, 0, 0, w, h);
        } catch (e) { out = null; }
        try {
          renderer.setPixelRatio(oldPR); renderer.setSize(oldSize.x, oldSize.y, false);
          camera.aspect = oldAspect; camera.updateProjectionMatrix();
          target.copy(oldTarget); controls.target.copy(target); camera.position.copy(oldPos); camera.lookAt(target);
          renderer.render(scene, camera);
        } catch (e2) { }
        return out;
      },
      // extra (not in the contract): small debug numbers for testing
      stats: function () {
        if (disposed) return null;
        var m = renderer.info.memory, r = renderer.info.render;
        return { geometries: m.geometries, textures: m.textures, frame: r.frame, calls: r.calls, triangles: r.triangles,
          clothVertices: coverN, family: C ? C.fam : null, key: C ? C.key : null };
      },
      dispose: function () {
        if (disposed) return;
        disposed = true;
        if (raf) win.cancelAnimationFrame(raf);
        if (backupT) win.clearTimeout(backupT);
        raf = 0; backupT = 0; tween = null;
        try { if (ro) ro.disconnect(); } catch (e) { }
        win.removeEventListener("resize", onWinResize);
        doc.removeEventListener("visibilitychange", onVis);
        canvas.removeEventListener("webglcontextlost", onLost, false);
        canvas.removeEventListener("webglcontextrestored", onRestored, false);
        controls.removeEventListener("change", onControlsChange);
        controls.removeEventListener("start", onControlsStart);
        controls.removeEventListener("end", onControlsEnd);
        controls.dispose();
        disposeGeos();
        if (ground) ground.geometry.dispose();
        var list = [coverMat, groundMat, groundTex, tex.t], k;
        for (k in M) if (M.hasOwnProperty(k)) list.push(M[k]);
        for (k = 0; k < list.length; k++) try { if (list[k]) list[k].dispose(); } catch (e3) { }
        tex.t = tex.src = null;
        try { renderer.dispose(); renderer.forceContextLoss(); } catch (e4) { }
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }
    };
    function onWinResize() { api.resize(); }
    function onLost(e) { e.preventDefault(); }
    function onRestored() { invalidate(); }
    function onVis() { if (!doc.hidden) invalidate(); }
    canvas.addEventListener("webglcontextlost", onLost, false);
    canvas.addEventListener("webglcontextrestored", onRestored, false);
    doc.addEventListener("visibilitychange", onVis);
    var ro = null;
    if (win.ResizeObserver) { ro = new win.ResizeObserver(function () { api.resize(); }); ro.observe(host); }
    win.addEventListener("resize", onWinResize);

    api.set({ key: "TT6-4", family: "throw", sides: 4 });
    if (!measure()) controls.update();
    invalidate();
    canvas.setAttribute("data-ardor-table3d", "ready");
    return api;
  }

  root.ArdorTable3D = { create: create, version: "1.0.0" };
})(typeof window !== "undefined" ? window : this);
